import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import ModalContainer from '../Modals/ModalContainer';
import ModalHeader from '../Modals/ModalHeader';
import ModalContentCenter from '../Modals/ModalContentCenter';
import ModalText from '../Modals/ModalText';

const BASE_KEY = 'components.document_viewer';

function DocumentViewerAssetNotFound(props) {
    return (<div>
        <ModalContainer>
            <ModalHeader type="warning">
                {props.getMessage(`${BASE_KEY}.failed_header`)}
            </ModalHeader>
            <ModalContentCenter>
                <ModalText>
                    {props.getMessage(`${BASE_KEY}.failed_body`)}
                </ModalText>
            </ModalContentCenter>
        </ModalContainer>
    </div>)
}

DocumentViewerAssetNotFound.propTypes = {
    getMessage: PropTypes.func.isRequired,
};

DocumentViewerAssetNotFound.displayName = displayName('DocumentViewer/DocumentViewerAssetNotFound',);

export default DocumentViewerAssetNotFound;
